<template>
  <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-4" >
    <router-link
      class="text-decoration-none text-black"
      :to="{
        name: 'course-data',
        params: {
          id: item.id,
          name: linkString( item.name ),
          author: linkString( item.user.name )
        }
      }"
    >
      <div class="card rounded-3 course-item" style="height: 380px;">
        <div class="card-body p-0 m-0 rounded-0 p-2 position-relative">
          <!-- lazy loader -->
            <img v-if="item.thumbnail" class="card-img rounded-3" :src="`${ api_url }${ item.thumbnail.url }`">
            <div class="px-1 py-2">
              <h6>{{ item.name }}</h6>

              <user-data :user="item.user" />
              <course-values class="position-absolute w-100 pr-4" style="bottom: 0;" :item="{
                'workload': item.workload,
                'value': item.value,
                'value_sale': item.value_sale,
                'is_free': item.is_free,
              }" />
          </div>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
import UserData from './User/UserData';
import CourseValues from './Values'

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  components: {
    "user-data": UserData,
    "course-values": CourseValues
  },
  data () {
    return {
      api_url: process.env.VUE_APP_ROOT_BASE
    }
  },
  methods: {
    linkString: function ( string ) {
      string = string.toLowerCase()
      string = string.split(' ')
      string = string.join('-')
      return string
    }
  }
}
</script>

<style scoped>

</style>
